// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import makeBulkUpdateSiteModeInitialValues from './makeBulkUpdateSiteModeInitialValues'
import makeBulkUpdatePathModeInitialValues from './makeBulkUpdatePathModeInitialValues'
import { ProjectTypeIdEnum } from 'config/enums'

import {
  BULK_EDITS_FILTER,
  BULK_EDITS_FORM,
} from 'components/BulkUpdates/constants'

// this thunk initializes the Bulk Edits redux form
// based on how the BULK_EDITS_FILTER form is currently set.
// this way we can use the single redux-form instance to handle
// the different Bulk Edit modes.

const initializeBulkUpdateForm = () => (dispatch, getState) => {
  const {
    form,
    pathDetails,
    projectSummary,
  } = getState()

  // hide admin fields for the bulk edit form if we're within an Engineering Project.
  const hideAdminFields = (
    pathDetails.get('withinProjectSummary') &&
    projectSummary.getIn(['projectType', 'projectTypeId']) === ProjectTypeIdEnum.ENGINEERING
  )

  // based on the current edit mode assigned to the filter form,
  // initialize the update form accordingly.
  const {
    bandId,
    bulkMode,
  } = form[BULK_EDITS_FILTER].values

  const modeSpecificValues = dispatch(
    bulkMode === 'site'
      ? makeBulkUpdateSiteModeInitialValues()
      : makeBulkUpdatePathModeInitialValues()
  )

  // band vs bandId
  // there is a discrepancy in Path Details API where it takes the bandId as 'band'
  // because of this, the Path Details form has lookups which look for 'band'
  // when querying for antennas and radios.

  const initialValues = {
    ...modeSpecificValues,
    band: bandId,
    hideAdminFields,
  }

  return dispatch(initialize(BULK_EDITS_FORM, initialValues))
}

export default initializeBulkUpdateForm
